module.exports = __webpack_public_path__ + "img/249.2040f255.jpg";